import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";

import * as statisticsCategoryApi from "../../api/statisticsApi/statisticsCategoryApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as statisticsItem1Api from "../../api/statisticsApi/statisticsItem1Api";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {WOStatisticsCategory} from "../../models/serverModels/workOrder/WOStatisticsCategory";
import {
  WOStatisticsItem,
  initialStatisticsItemListParams,
  initializeStatisticsItem,
} from "../../models/serverModels/workOrder/WOStatisticsItem";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import StatisticsItem1Form from "./StatisticsItem1Form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const item2Schema = yup.object({
  itemName: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});

const UpdateItem1 = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data, isLoading: isGetLoading} = useQuery(
    ["statisticsCategoryList", {...initialStatisticsItemListParams, token: tokenState}],
    () => statisticsCategoryApi.getList({...initialStatisticsItemListParams, token: tokenState}),
    {
      select: (data: ResponseList<WOStatisticsCategory>) =>
        data?.items
          .find((item) => item?.uid === location.state)
          ?.items.find((value) => value?.uid === parseInt(id!)),
    }
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WOStatisticsItem>,
    Params.Update<WOStatisticsItem>
  >({
    api: statisticsItem1Api.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
    },
  });

  const methods = useForm<WOStatisticsItem>({
    defaultValues: data || initializeStatisticsItem,
    resolver: yupResolver(item2Schema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(data);
  }, [data, reset]);

  const onSubmit: SubmitHandler<WOStatisticsItem> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeStatisticsItem, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="항목 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <StatisticsItem1Form captionColor="#546E7A" />
            <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateItem1;
